import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ChannelCategoriesDto
*  Информация о категориях, в рамках канала данных
*/
export class ChannelCategoriesDto extends ActiveModel {

  /**
  * allByIds
  * Словарь с информацией о всех категориях, где: <para /><br>- ключ: идентификатор категории; <para /><br>- значение: данные категории<br>  */
  @ActiveField(() => undefined)
  allByIds?: Record<string, object>


/**
  * rootIds
  * Идентификаторы корневых категорий<br>  */
  @ActiveField({
    setter(model: ChannelCategoriesDto, prop: string, value: Array<number> | undefined, receiver?: ChannelCategoriesDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => Number.parseInt(v)) : value,
        
        receiver)
    }
  })
  rootIds?: Array<number>
}
